export const gateCheckInByShipment = /* GraphQL */ `
  query GateCheckInByShipment(
    $shipmentKey: String
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    gateCheckInByShipment(
      shipmentKey: $shipmentKey
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        driverSessionId
        carrierUserId
        driverName
        carrierName
        shipmentKey
        inboundId
        outboundId
        outboundIds
        timeslotId
        scheduledDateTime
        referenceEntered
        truckPlate
        trailerNumber
        status
        dockAssignment
        arrivedAt
        updatedBy
      }
      nextToken
    }
  }
`;

export const gateCheckInByYardByStatus = /* GraphQL */ `
  query GateCheckInByYardByStatus(
    $reloadYardId: ID
    $statusArrivedAt: ModelGateCheckInGateCheckInByYardByStatusCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $limit: Int
    $nextToken: String
  ) {
    gateCheckInByYardByStatus(
      reloadYardId: $reloadYardId
      statusArrivedAt: $statusArrivedAt
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reloadYardId
        driverSessionId
        carrierUserId
        driverName
        carrierName
        shipmentKey
        inboundId
        outboundId
        outboundIds
        timeslotId
        scheduledDateTime
        referenceEntered
        truckPlate
        trailerNumber
        status
        dockAssignment
        arrivedAt
        updatedBy
      }
      nextToken
    }
  }
`;
